import { noop } from '@philips-internal/oswald-ui-utils';
function createStatefulComponent(name, ComponentType) {
    return class StatefulComponent extends ComponentType {
        // @ts-ignore
        static get name() {
            return name;
        }
        // TODO: maybe unnecessary?
        static get propTypes() {
            return ComponentType.propTypes;
        }
        constructor(props) {
            super(props);
            this.unsubscribeFromSSOT = noop;
            this.onSSOTStateChange = (state) => {
                this.setState(state);
            };
        }
        componentDidMount() {
            const { ssot } = this.props;
            this.unsubscribeFromSSOT = ssot.subscribeToState(this.onSSOTStateChange);
            if (this.state) {
                ssot.apply({ ...this.state });
            }
            if (super.componentDidMount) {
                super.componentDidMount();
            }
        }
        componentWillUnmount() {
            if (super.componentWillUnmount) {
                super.componentWillUnmount();
            }
            this.unsubscribeFromSSOT();
        }
        setState(partialState, callback) {
            super.setState((...args) => {
                let result = partialState;
                if (typeof result === 'function') {
                    result = partialState(...args);
                }
                this.props.ssot.apply(result);
                return result;
            }, callback);
        }
    };
}
export { createStatefulComponent, };
//# sourceMappingURL=stateful-component.js.map